import styled from "styled-components";
import type { DefaultTheme } from "styled-components";
import { ColorType } from "@ifgengineering/component-library";
import { switchProp } from "styled-tools";

export type WrapperWidth = "COMPACT" | "NARROW" | "LARGE" | "FULL";

// Callers only ever ask for SLATE200 or WHITE. Resolving both through the theme
// keeps the light values identical while letting the page follow dark mode.
const pageFill = (theme: DefaultTheme, background?: ColorType): string =>
  background === "WHITE"
    ? theme.colors.ui.background.raised
    : theme.colors.ui.background.page;

export const PageWrapper = styled.div<{
  background?: ColorType;
  $allowSticky?: boolean;
}>`
  background: ${({ theme, background }) => pageFill(theme, background)};
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Hidden overflow makes this a scroll container, which pins sticky children to it; clip does not. */
  overflow: ${({ $allowSticky }) => ($allowSticky ? "clip" : "hidden")};
  flex-grow: 1;
  height: 100%;
  @media (max-width: 1077px) {
    padding: 0 40px;
  }
`;

export const ContentWrapper = styled.div<{
  width?: WrapperWidth;
  padding?: string;
}>`
  width: 100%;
  padding: ${({ padding }) => padding || "48px 0"};
  padding-top: 34px;
  max-width: ${switchProp("width", {
    COMPACT: "540px",
    NARROW: "944px",
    LARGE: "1200px",
    FULL: "100%",
  })};
`;

export const HeaderWrapper = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;

  /* The title and subtitle come from a component whose colour is hardcoded. */
  > div > * {
    color: ${({ theme }) => theme.colors.ui.text.primary};
  }
`;
